module.exports = __webpack_public_path__ + "static/media/play.deac732a.png";